module.exports = __webpack_public_path__ + "img/4064001610.92478ac6.jpg";